<p-dialog
  [visible]="tipsService.applyDialogVisible()"
  (visibleChange)="!$event && close()"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="!tipsService.isApplying()"
  [closable]="!tipsService.isApplying()"
  [style]="{ width: '560px', maxWidth: 'calc(100vw - 32px)' }"
>
  <ng-template pTemplate="header">
    <div class="flex min-w-0 flex-col gap-0.5">
      <h2
        class="flex items-center gap-2 text-heading-4 font-semibold text-primary-900"
      >
        <lucide-icon name="lightbulb" [size]="20" class="text-primary-600" />
        {{ "reductionTips.applyDialog.title" | transloco }}
      </h2>
      <p class="text-paragraph-s-reg text-greyscale-600">
        {{
          "reductionTips.applyDialog.summary"
            | transloco
              : {
                  count: selectedCount(),
                  savings: tipsService.formattedAvoided(),
                }
        }}
      </p>
    </div>
  </ng-template>

  <div class="flex flex-col gap-2.5">
    <label
      for="apply-target-overwrite"
      class="grid cursor-pointer grid-cols-[18px_minmax(0,1fr)] gap-3 rounded-lg border px-3.5 py-3 transition-colors"
      [class]="
        target() === 'overwrite'
          ? 'border-primary-500 bg-primary-50'
          : 'border-greyscale-200 hover:border-primary-300'
      "
    >
      <p-radiobutton
        name="applyTarget"
        value="overwrite"
        [ngModel]="target()"
        (ngModelChange)="choose($event)"
        inputId="apply-target-overwrite"
      />
      <span class="flex min-w-0 flex-col gap-1">
        <span
          class="flex items-center gap-2 text-paragraph-s-reg font-semibold text-primary-900"
        >
          <lucide-icon name="edit" [size]="16" class="text-primary-600" />
          {{ "reductionTips.applyDialog.overwrite.title" | transloco }}
        </span>
        <span class="text-paragraph-xs-reg text-greyscale-700">
          {{
            "reductionTips.applyDialog.overwrite.description"
              | transloco: { title: tripTitle() }
          }}
        </span>
      </span>
    </label>

    <label
      for="apply-target-copy"
      class="grid grid-cols-[18px_minmax(0,1fr)] gap-3 rounded-lg border px-3.5 py-3 transition-colors"
      [class]="
        !canCopy()
          ? 'cursor-not-allowed border-greyscale-200 bg-greyscale-50 opacity-70'
          : target() === 'copy'
            ? 'cursor-pointer border-primary-500 bg-primary-50'
            : 'cursor-pointer border-greyscale-200 hover:border-primary-300'
      "
    >
      <p-radiobutton
        name="applyTarget"
        value="copy"
        [ngModel]="target()"
        (ngModelChange)="choose($event)"
        inputId="apply-target-copy"
        [disabled]="!canCopy()"
      />
      <span class="flex min-w-0 flex-col gap-1">
        <span
          class="flex items-center gap-2 text-paragraph-s-reg font-semibold text-primary-900"
        >
          <lucide-icon
            [name]="canCopy() ? 'copy' : 'lock'"
            [size]="16"
            class="text-primary-600"
          />
          {{ "reductionTips.applyDialog.copy.title" | transloco }}
        </span>
        <span class="text-paragraph-xs-reg text-greyscale-700">
          {{
            "reductionTips.applyDialog.copy.description"
              | transloco: { title: tripTitle() }
          }}
        </span>
        @if (canCopy()) {
          <span class="text-paragraph-xs-reg font-medium text-greyscale-600">
            {{
              "reductionTips.applyDialog.copy.cost"
                | transloco: { count: packLimitations.remainingTrips() }
            }}
          </span>
        } @else {
          <span class="text-paragraph-xs-reg font-medium text-error-700">
            {{ "reductionTips.applyDialog.copy.limitReached" | transloco }}
          </span>
        }
      </span>
    </label>

    @if (!canCopy()) {
      <app-trip-limit-indicator />
    }
  </div>

  <ng-template pTemplate="footer">
    <div class="flex w-full flex-wrap items-center justify-end gap-3">
      <p-button
        [label]="'common.cancel' | transloco"
        severity="secondary"
        [text]="true"
        size="small"
        [disabled]="tipsService.isApplying()"
        (onClick)="close()"
      />
      <p-button
        [label]="
          'reductionTips.applyDialog.' + target() + '.confirm' | transloco
        "
        size="small"
        [loading]="tipsService.isApplying()"
        [disabled]="tipsService.isApplying()"
        (onClick)="confirm()"
      />
    </div>
  </ng-template>
</p-dialog>
